import type { SelectOption } from '../../../SelectDropdown/SelectDropdown'

export interface NamedRecord {
  id: string
  name: string
}

export const toOptions = (records: NamedRecord[] | undefined): SelectOption[] =>
  (records ?? []).map((record) => ({ id: record.id, label: record.name })).sort((a, b) => a.label.localeCompare(b.label))
